import {
  IReservationObjectData,
  TUnits,
} from 'modules/accommodations/features/reservations/models';

export const localStorageValuesFromFirstStep = (localstorageFirstStep: any) => {
  let from = '';
  let to = '';
  let numberOfGuestsSum = 0;
  let propertyId = '';
  let unitId = '';
  let languageId = 0;
  let adultsNumber = 0;
  let babiesNumber = 0;
  let childrenNumber = 0;
  let teensNumber = 0;
  let partnerValue = '';
  let serviceId = 0;
  let currencyId = 0;
  let calculationStatus = 0;

  if (localstorageFirstStep) {
    const { formValues: localStorageValues, tableData: localStorageReserObjects } =
      localstorageFirstStep;

    const {
      date,
      adults,
      babies,
      children,
      teens,
      languageId: languageIdValue,
      partner,
      serviceId: serviceIdValue,
      currencyId: currencyIdValue,
      calculationStatus: calculationStatusValue,
    } = localStorageValues;

    from = date[0];
    to = date[1];
    numberOfGuestsSum = adults + babies + children + teens;
    propertyId = localStorageReserObjects
      ?.map((item: IReservationObjectData) => item.propertyId)
      .join(' ');
    unitId = localStorageReserObjects?.map((item: IReservationObjectData) =>
      item.units.map((unit: TUnits) => unit.unitId).join(),
    );
    languageId = languageIdValue;
    adultsNumber = adults;
    babiesNumber = babies;
    childrenNumber = children;
    teensNumber = teens;
    partnerValue = partner;
    serviceId = serviceIdValue;
    currencyId = currencyIdValue;
    calculationStatus = calculationStatusValue;
  }

  return {
    from,
    to,
    numberOfGuestsSum,
    propertyId,
    unitId,
    languageId,
    adultsNumber,
    babiesNumber,
    childrenNumber,
    teensNumber,
    partnerValue,
    serviceId,
    currencyId,
    calculationStatus,
  };
};
